module.exports = __webpack_public_path__ + "static/media/institute-15-min.86a30e4e.webp";